import React, { useState } from 'react';

import { t } from 'i18next';
import { useFormik } from 'formik';

import Yup from '../../../../utils/yupExtensions';
import styles from './EmployerPortalJobDetail.module.css';
import FormSelectField from '../../UpdatedFormUI/FormSelectField/FormSelectField';

function PerformanceFilter(activeButton, setActiveButton,formik) {
    // const [activeButton, setActiveButton] = useState('Daily');

    const FILTERBUTTONS = [
        t('general.performance.filters.daily'),
        t('general.performance.filters.weekly'),
        t('general.performance.filters.monthly')
    ];
   
    const ENGAGEMENTMETRICS = [
        { value: 'Views', label: t('general.performance.metrics.views') },
        { value: 'Impressions', label: t('general.performance.metrics.impressions') },
        { value: 'Applications', label: t('general.performance.metrics.applications') }
    ];
    return (
        <div className={styles.performanceContainer}>
            <div className={`${styles.buttonFilterContainer} ${styles.height44} ${styles.categoryContainer}`} >
                <FormSelectField
                    name="engagementFilter"
                    placeholder={t('general.UI.select')}
                    type="default"
                    hasBorder
                    options={ENGAGEMENTMETRICS}
                    onFormikChange={formik.handleChange}
                    styles={{
                        control: (base) => ({
                            ...base,
                            backgroundColor: '#F2FBFE',
                        }),
                    }}
                    value={formik.values.engagementFilter}
                    themeLight
                    error={formik.touched.engagementFilter && formik.errors.engagementFilter}
                />

            </div>
            <div className={`${styles.buttonFilterContainer} ${styles.height44}`} style={{ flexWrap: "wrap" }} >
                {FILTERBUTTONS.map((item, index) => {
                    return (
                        <div
                            key={index.toString()}
                            className={styles.buttonWrapper}
                            onClick={() => setActiveButton(item)}
                        >
                            <div className={activeButton === item ? styles.activeButtonTitle : styles.buttonTitle}>{item}</div>
                            {index < FILTERBUTTONS.length - 1 && <div className={styles.saperator}></div>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default PerformanceFilter;






